<template>
  <div class="wg-row">
    <div class="analysis-list">
      <div v-for="(doc, index) in docs" :key="'doc-'+index" class="list-item">
        <div :class="['item', doc.type]">
          <div v-if="doc.type == 'form'">Verbale {{ doc.formCode }} - {{ doc.name }} <span class="date">({{ doc.createdAt.substring(0, 10) }})</span></div>
          <div v-if="doc.type == 'coc'">Presa in carico COC {{ doc.analysisCode }} <span class="date">({{ doc.createdAt.substring(0, 10) }})</span></div>
          <div v-if="doc.type == 'preview'">Anteprima analisi {{ doc.analysisCode }} <span class="date">({{ doc.createdAt.substring(0, 10) }})</span></div>
          <div v-if="doc.type == 'report'">Report analisi {{ doc.analysisCode }} <span class="date">({{ doc.createdAt.substring(0, 10) }})</span></div>
          <div v-if="doc.files.length > 0" class="files-list">
            <img v-for="(fileId, fIndex) in doc.files" :key="'file-' + fIndex" :src="$anm22.icons.getWorldIcon('fileDefault')" @click="openDocAttachment(doc, fileId)" />
          </div>
        </div>
      </div>
      <div v-if="docs.length <= 0">{{ $anm22.strLang(lang, 'No items', 'Nessun campione associato al progetto.') }}</div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
  },
  data() {
    return {
      docs: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      offline: (state) => state.offline.isOffline
    }),
    
  },
  methods: {
    openDocAttachment(doc, fileId) {
      if (doc.type == 'form') {
        window.open(fileId, '_blank');
      } else {
        window.open('https://www.anm22.it/app/tasks/spa/controller/coc/file?idCoc=' + doc.idCoc + '&file=' + fileId, '_blank');
      }
    },
  },
  async created() {
    const response = await this.$http.get(
      "coc/index?projectId=" + this.projectId
    );
    this.docs = response.data.docs;
  }
};
</script>
 
<style lang="scss" scoped>
  .analysis-list {
    .list-item {
      .item {
        padding: 3px 0 3px 10px;
        font-size: 16px;

        &.form {
          padding-left: 0;
          font-weight: bold;
        }

        span.date {
          font-size: 14px;
          color: #666;
          font-weight: normal;
        }

        &>div {
          display: inline-block;
          vertical-align: middle;

          &.files-list {
            margin: 0 0 0 4px;
            img {
              opacity: 0.6;
              cursor: pointer;
              display: inline-block;
              margin: 0;
              padding: 4px;
              border-radius: 50%;

              &:hover {
                background-color: #ddd;
              }
            }
          }
        }
      }
    }
  }
</style>
 